// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__mN9tW","ScrollX":"Scroll_ScrollX__gT655","ScrollY":"Scroll_ScrollY__2HwUK"};